import React, { Component } from 'react'
import Select from 'react-select'
import apiService from '../../services/ApiService'

class Departments extends Component {
    constructor() {
        super()
        this.state = {
            departmentsList: {},
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getDepartmentsList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getDepartmentsList = () => {
        apiService.getDepartmentsDetailList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        departmentsList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }
    

    render() {
        let list = {}
        list = Object.keys(this.state.departmentsList).map((value,index) => {
            
            return {
                label : this.state.departmentsList[value],
                value : value
            }
        })
        list.sort((a,b) => a.label.localeCompare(b.label));

        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Department"
                options={list}
                onChange={(e) => { (e) ? this.props.departmentChange(e) : this.props.departmentChange([])}}
                />
            </div>
        )
    }
}
export default Departments


// WEBPACK FOOTER //
// ./src/common/DropDowns/Departments.js